import Cookies from "js-cookie";

class RecaptchaV2 {
  static start() {
    document.addEventListener("DOMContentLoaded", () => {
      $("#verify_recaptcha_modal_btn").click(() => {
        var token = $("#g-recaptcha-response").val();
        $.ajax({
          type: "GET",
          url: "/api/recaptchas",
          cache: false,
          data: { token: token, version: "v2" },
          success: function (res) {
            try {
              var box = $(".verify_recaptcha_modal");
              if (res && res.res && res.res.success === false) {
                alert("認証に失敗しました。");
                grecaptcha.reset();
              } else if (res && res.res && res.res.success) {
                Cookies.set("recaptcha_auth", true, { expires: 30, path: "/" });
                box.removeClass("verify_recaptcha_js_modal");
              } else {
                // 検証不能 (Google通信失敗による204等) は実ユーザーの閲覧を妨げないよう
                // cookieを付与せずモーダルのみ閉じる (v3側のfail-open方針に合わせる)
                box.removeClass("verify_recaptcha_js_modal");
                // 無音でfail-openし続けると障害に気付けないため通知しておく
                window.webpackBugsnagClient?.notify("recaptcha v2が検証不能(204等の空レスポンス)のためfail-openしました");
              }
            }
            catch (e) {
              // grecaptcha読み込みエラー以外はbugsnagに通知しておく
              if (e != "ReferenceError: grecaptcha is not defined") {
                window.webpackBugsnagClient?.notify(e);
              }
            }
          },
          error: function (_data, status, _headers, _config) {
            // API自体のエラー時も検証不能として通す
            $(".verify_recaptcha_modal").removeClass("verify_recaptcha_js_modal");
            // 無音でfail-openし続けると障害に気付けないため通知しておく
            window.webpackBugsnagClient?.notify("recaptcha v2の検証APIエラーのためfail-openしました: " + status);
          }
        });
      });
    });
  }
}

export default RecaptchaV2;
